import { Form, Formik } from 'formik';
import { ValidationTracker } from 'components/domain/ValidationTracker/ValidationTracker';
import { GenericLoading } from 'components/ui/Loader';
import { QuoteMandateLayout } from './QuoteMandateLayout';
import { useQuoteMandateForm } from '../../forms/quote-mandate';

interface QuoteMandateFormProps {
  onSuccess?: () => void;
}

export const QuoteMandateForm: React.FC<QuoteMandateFormProps> = ({
  onSuccess
}) => {
  const {
    formikRef,
    initialValues,
    validationSchema,
    isLoading,
    setIsFormValid,
    onSubmit,
    formKey
  } = useQuoteMandateForm({ onSuccess });

  return (
    <div className="relative">
      {isLoading && <GenericLoading loading isParentSized />}
      <Formik
        key={formKey}
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        innerRef={formikRef}
      >
        {({ isValid }) => (
          <>
            {/* Reports the validity from an effect: setting the parent state while Formik renders is a React error. */}
            <ValidationTracker isValid={isValid} onValidationChange={setIsFormValid} />
            <Form>
              <QuoteMandateLayout />
            </Form>
          </>
        )}
      </Formik>
    </div>
  );
};
